import { IPopoverProps } from "./PopoverTypes"

import {
  Popover as ChakraPopover,
  PopoverContent,
  PopoverTrigger,
  PopoverArrow,
} from "@chakra-ui/react"

const Popover: React.FC<IPopoverProps> = ({
  rootElement,
  content,
  placement,
  variant = "solid_white",
  size = "base",
  ...rest
}) => {
  return (
    <ChakraPopover placement={placement} variant={variant} size={size} {...rest}>
      <PopoverTrigger>{rootElement}</PopoverTrigger>
      <PopoverContent>
        {content}
        <PopoverArrow />
      </PopoverContent>
    </ChakraPopover>
  )
}

export default Popover
